<fieldset class=" mgn-bottom-25">
    <legend class="accesibleHidden">Datos del recomendador</legend>
    <div class="form-row">
        <div class="col-12 col-md-6">
            <form-group-text [control]="referenceName" [id]="sufix +'course-name-admin'" [title]="'Nombre recomendador/a'"
                [maxlength]="100" [placeholder]="'Ingrese el nombre del recomendador/a'"
                [messageRequired]="'Nombre recomendador/a es requerido.'">
            </form-group-text>

        </div>
        <div class="col-12 col-md-6">

            <form-group-select-search [id]="sufix + 'input-position-reference'" [title]="'Cargo'"
                [placeholder]="'Seleccione un cargo'" [control]="referencePosition" [dataSelect]="POSITION_LIST"
                [messageRequired]="'Cargo es requerido.'">
            </form-group-select-search>

        </div>
    </div>
    <div class="form-row">
        <div class="col-12 col-md-6">
            <form-group-text [popoverContent]="'Institución actual de la persona referida'"
                [control]="referenceInstitution" [id]="sufix + 'input-reference-institution'" [title]="'Institución'"
                [maxlength]="100" [placeholder]="'Institución la institución del recomendador/a'"
                [messageRequired]="'Institución es requerida.'">
            </form-group-text>
        </div>
        <div class="col-12 col-md-6">

            <form-group-phone [control]="referencePhoneNumber" [id]="sufix + 'input-reference-phone'"
                [title]="'Número celular recomendador/a'" [placeholder]="'Ingresa ocho dígitos'"
                [messageRequired]="'Número celular es requerido.'">
            </form-group-phone>
        </div>
    </div>
    <div class="form-row">
        <div class="col-12 col-md-6">
            <form-group-text [control]="referenceEmail" [id]="sufix + 'input-reference-email'" [title]="'Email'"
                [placeholder]="'Ingresa su correo electrónico'" [messageRequired]="'Email es requerido.'"
                [messagePattern]="'El email ingresado no tiene un formato valido.'">
            </form-group-text>
        </div>
    </div>

    <div class="form-row">
        <div class="col-12">
            <div class="form-group">
                <small class="form-text mgn-bottom-25 text-muted">Al agregar esta referencia laboral acepto que
                    ProfeJOBS le envíe un correo para que esta persona pueda escribir una referencia sobre mí.</small>
            </div>
        </div>
    </div>

</fieldset>